module.exports = __webpack_public_path__ + "media/images/plans/photo_chapel/setplan-2-363a0597313836b8590ce4dcbe2c05f2.png";